import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AboutPaymentAnticipationDetails } from "@/components/payment/about-payment-anticipation-details";

import type { JSX } from "react";

const AboutPaymentAnticipationPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Sobre" align="center" />
      </HeaderRoot>
      <Page>
        <AboutPaymentAnticipationDetails />
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/about-payment-anticipation",
)({
  component: AboutPaymentAnticipationPage,
});
